import { useLocale as useLocaleBase } from 'shared-ui';

export const useLocale = useLocaleBase;
